import { defineMessages, type IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import TrailSuitability from '../types/TrailSuitability';

const messages = defineMessages<TrailSuitability>({
  ada: { defaultMessage: 'Wheelchair-friendly' },
  dogs: { defaultMessage: 'Dog-friendly' },
  kids: { defaultMessage: 'Kid-friendly' },
  'partially-paved': { defaultMessage: 'Partially paved' },
  paved: { defaultMessage: 'Paved' },
  strollers: { defaultMessage: 'Stroller-friendly' }
});

export default function getTrailSuitabilityLabel(intl: IntlShape, suitability: TrailSuitability): string {
  const message = messages[suitability];

  if (message) {
    return intl.formatMessage(message);
  }

  logError(new Error(`Unknown suitability: ${suitability}`));
  return '';
}

export function suitabilityInfo(suitability: TrailSuitability, intl: IntlShape): string {
  if (suitability === 'ada') {
    return intl.formatMessage({
      defaultMessage:
        'This rating is based on trail width, grade, cross-slopes, obstacles, surface firmness and type. Wheelchair friendly does not mean a trail is certified to be compliant with all country-specific accessibility legal standards. Note that trail conditions can vary depending on time, weather and other events. Consider user skill and equipment type when choosing your trail.'
    });
  }
  return '';
}
